import { useEffect, useState } from "react";
import { useStaffChat } from "./StaffChatProvider";

const PAGE_SIZE = 30;
const MAX_PAGES = 10;

// Staff of the logged in user's organisation (without the user itself).
// Stream adds the organisation (team) filter by itself, so no team filter is sent from here.
const useOrgUsers = (enabled = true) => {
  const { client, ready, currentUserId } = useStaffChat();

  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!enabled || !ready || !client) {
      return;
    }

    let cancelled = false;

    const fetchUsers = async () => {
      setLoading(true);
      setError("");

      try {
        let allUsers = [];

        // Stream cannot sort by name, so all the staff are loaded and sorted here
        for (let page = 0; page < MAX_PAGES; page++) {
          const response = await client.queryUsers(
            { id: { $ne: currentUserId } },
            { id: 1 },
            { limit: PAGE_SIZE, offset: page * PAGE_SIZE, presence: true }
          );
          if (cancelled) {
            return;
          }

          const pageUsers = response?.users || [];
          allUsers = allUsers.concat(pageUsers);

          if (pageUsers.length < PAGE_SIZE) {
            break;
          }
        }

        allUsers.sort((a, b) =>
          (a.name || a.id).localeCompare(b.name || b.id)
        );

        setUsers(allUsers);
      } catch (error) {
        if (!cancelled) {
          console.error("Error fetching chat users:", error);
          setUsers([]);
          setError("Unable to load the staff list. Please try again.");
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    fetchUsers();

    return () => {
      cancelled = true;
    };
  }, [enabled, ready, client, currentUserId]);

  return { users, loading, error };
};

export default useOrgUsers;
